import { useEffect, useState } from "react";
import MainCard from "../../componentes/card/MainCard";
import { Loading } from "../../componentes/loading/loading";
import { useMeuUsuario } from "../../hooks/meuUsuario/useMeuUsuario";
import DadosUsuarioCard from "../../components/meuUsuario/DadosUsuarioCard";
import AlterarSenhaCard from "../../components/meuUsuario/AlterarSenhaCard";
import AssinaturaCard from "../../components/meuUsuario/AssinaturaCard";
import PreferenciasNotificacaoCard from "../../components/meuUsuario/PreferenciasNotificacaoCard";

const ABAS = [
    { key: "dados", label: "Dados do Usuário", icon: "fa fa-id-card" },
    { key: "senha", label: "Alterar Senha", icon: "fa fa-lock" },
    { key: "assinatura", label: "Assinatura", icon: "fa fa-signature" },
    { key: "notificacoes", label: "Notificações", icon: "fa fa-bell" },
];

export default function MeuUsuario() {
    const { perfil, loading, recarregar } = useMeuUsuario();
    const [abaAtiva, setAbaAtiva] = useState("dados");

    useEffect(() => { document.title = "MyDash | Meu Usuário"; }, []);

    return (
        <MainCard icon="fa fa-user-circle" title="Meu Usuário">
            <div className="px-6 pt-4">
                {loading ? (
                    <Loading label="Carregando seus dados..." />
                ) : (
                    <>
                        <div className="flex flex-wrap gap-1 border-b border-border">
                            {ABAS.map(aba => (
                                <button
                                    key={aba.key}
                                    type="button"
                                    onClick={() => setAbaAtiva(aba.key)}
                                    className={`flex items-center gap-2 px-4 py-2.5 -mb-px text-sm font-medium border-b-2 transition-colors duration-150 ${
                                        abaAtiva === aba.key
                                            ? "border-primary text-primary"
                                            : "border-transparent text-muted-foreground hover:text-foreground"
                                    }`}
                                >
                                    <i className={aba.icon} />
                                    {aba.label}
                                </button>
                            ))}
                        </div>

                        <div className="pt-2 pb-4">
                            {abaAtiva === "dados" && <DadosUsuarioCard perfil={perfil} />}
                            {abaAtiva === "senha" && <AlterarSenhaCard />}
                            {abaAtiva === "assinatura" && <AssinaturaCard />}
                            {abaAtiva === "notificacoes" && <PreferenciasNotificacaoCard perfil={perfil} onSalvo={recarregar} />}
                        </div>
                    </>
                )}
            </div>
        </MainCard>
    );
}
